import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";

import Select from "../components/Select.js";
import InputNumber from "../components/InputNumber.js";
import Output from "../components/Output.js";

import { timberBendingCombined } from "../../utils/services/calculators.js";
import { Text, useToast } from "@chakra-ui/react";

function TimberBendingCombined({}) {
  const toast = useToast();
  // BENDING
  const [bendingCombinedInputs, setBendingCombinedInputs] = useState({
    forest_type: "Nativa",
    timber: "Coníferas",
    timber_class: "D20",
    timber_type: "Madeira serrada",
    load_class: "Permanente",
    moisture_class: "1 (≤ 65%)",
    lx: "",
    ke_x: 1,
    ly: "",
    ke_y: 1,
    b: "",
    h: "",
    af: "",
    stress_type: "Tração",
    nsd: "",
    msd_x: "",
    msd_y: 0,
  });
  const [bendingCombinedOutputs, setBendingCombinedOutputs] = useState({
    fc0_d: "",
    ft0_d: "",
    l0_x: "",
    l0_y: "",
    lambd_x: "",
    lambd_y: "",
    tens_nc_d: "",
    tens_nt_d: "",
    lambd_rel_x: "",
    verification_x: "",
    lambd_rel_y: "",
    verification_y: "",
    fm_d: "",
    tens_mx_d: "",
    oblique_verification_x: "",
    limit_1: "",
    limit_2: "",
    verification: "",
    memorial: {},
  });

  function updateBendingCombinedInputs(name, value) {
    if (
      name === "forest_type" ||
      name === "timber" ||
      name === "timber_class" ||
      name === "timber_type" ||
      name === "load_class" ||
      name === "moisture_class" ||
      name === "stress_type"
    ) {
      if (value === "Nativa") {
        setBendingCombinedInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D20",
        }));
      } else if (value === "Plantada") {
        setBendingCombinedInputs((prevInputs) => ({
          ...prevInputs,
          ["timber"]: "Coníferas",
        }));
        setBendingCombinedInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      }
      if (value === "Coníferas") {
        setBendingCombinedInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      } else if (value === "Folhosas") {
        setBendingCombinedInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D18",
        }));
      }
      setBendingCombinedInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else if (value === "") {
      setBendingCombinedInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setBendingCombinedInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setBendingCombinedOutputs({
      fc0_d: "",
      ft0_d: "",
      l0_x: "",
      l0_y: "",
      lambd_x: "",
      lambd_y: "",
      tens_nc_d: "",
      tens_nt_d: "",
      lambd_rel_x: "",
      verification_x: "",
      lambd_rel_y: "",
      verification_y: "",
      fm_d: "",
      tens_mx_d: "",
      oblique_verification_x: "",
      limit_1: "",
      limit_2: "",
      verification: "",
    });
  }

  function onBendingCombinedCalculate() {
    if (
      bendingCombinedInputs["lx"] === "" ||
      bendingCombinedInputs["ly"] === "" ||
      bendingCombinedInputs["b"] === "" ||
      bendingCombinedInputs["h"] === "" ||
      bendingCombinedInputs["af"] === "" ||
      bendingCombinedInputs["nsd"] === "" ||
      bendingCombinedInputs["msd_x"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      bendingCombinedInputs["lx"] === 0 ||
      bendingCombinedInputs["ly"] === 0 ||
      bendingCombinedInputs["b"] === 0 ||
      bendingCombinedInputs["h"] === 0 ||
      bendingCombinedInputs["nsd"] === 0 ||
      bendingCombinedInputs["msd_x"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else {
      timberBendingCombined(bendingCombinedInputs).then((response) => {
        setBendingCombinedOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "timber-bending-combined-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", {
      page: "timber-bending-combined-calculator",
    });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Flexão Composta Normal:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Floresta"
              elements={["Nativa", "Plantada"]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedInputs("forest_type", e.target.value)
              }
              value={bendingCombinedInputs["forest_type"]}
            />
            {bendingCombinedInputs["forest_type"] === "Plantada" && (
              <Select
                text="Madeira"
                elements={["Coníferas", "Folhosas"]}
                unit=""
                onChange={(e) =>
                  updateBendingCombinedInputs("timber", e.target.value)
                }
                value={bendingCombinedInputs["timber"]}
              />
            )}
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Classe"
              elements={
                bendingCombinedInputs["forest_type"] === "Nativa"
                  ? ["D20", "D30", "D40", "D50", "D60"]
                  : bendingCombinedInputs["forest_type"] === "Plantada" &&
                      bendingCombinedInputs["timber"] === "Coníferas"
                    ? [
                        "C14",
                        "C16",
                        "C18",
                        "C20",
                        "C22",
                        "C24",
                        "C27",
                        "C30",
                        "C35",
                        "C40",
                        "C45",
                        "C50",
                      ]
                    : bendingCombinedInputs["forest_type"] === "Plantada" &&
                        bendingCombinedInputs["timber"] === "Folhosas"
                      ? ["D18", "D24", "D30", "D35", "D40", "D50", "D60", "D70"]
                      : []
              }
              unit=""
              onChange={(e) =>
                updateBendingCombinedInputs("timber_class", e.target.value)
              }
              value={bendingCombinedInputs["timber_class"]}
            />
            <Select
              text="Classe de umid."
              elements={["1 (≤ 65%)", "2 (≤ 75%)", "3 (≤ 85%)", "4 (> 85%)"]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedInputs("moisture_class", e.target.value)
              }
              value={bendingCombinedInputs["moisture_class"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Tipo"
              elements={[
                "Madeira serrada",
                "Madeira roliça",
                "Madeira lamelada colada (MLC)",
                "Madeira lamelada colada cruzada (MLCC)",
                "Madeira laminada colada (LVL)",
                "Madeira recomposta",
              ]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedInputs("timber_type", e.target.value)
              }
              value={bendingCombinedInputs["timber_type"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Classe de carregamento"
              elements={[
                "Permanente",
                "Longa duração",
                "Média duração",
                "Curta duração",
                "Instantânea",
              ]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedInputs("load_class", e.target.value)
              }
              value={bendingCombinedInputs["load_class"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Lx"
              unit="cm"
              onChange={(e) =>
                updateBendingCombinedInputs("lx", e.target.value)
              }
            />
            <Select
              text="Kex"
              elements={[0.65, 0.8, 1.2, 1, 2.1, 2.4]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedInputs("ke_x", e.target.value)
              }
              value={bendingCombinedInputs["ke_x"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Ly"
              unit="cm"
              onChange={(e) =>
                updateBendingCombinedInputs("ly", e.target.value)
              }
            />
            <Select
              text="Key"
              elements={[0.65, 0.8, 1.2, 1, 2.1, 2.4]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedInputs("ke_y", e.target.value)
              }
              value={bendingCombinedInputs["ke_y"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateBendingCombinedInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateBendingCombinedInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="af"
              unit="cm²"
              onChange={(e) =>
                updateBendingCombinedInputs("af", e.target.value)
              }
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Tipo de esforço"
              elements={["Tração", "Compressão"]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedInputs("stress_type", e.target.value)
              }
              value={bendingCombinedInputs["stress_type"]}
            />
            <InputNumber
              text="Nsd"
              unit="tf"
              onChange={(e) =>
                updateBendingCombinedInputs("nsd", e.target.value)
              }
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Msd,x"
              unit="tf.m"
              onChange={(e) =>
                updateBendingCombinedInputs("msd_x", e.target.value)
              }
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onBendingCombinedCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          <h4 className={styles.rowDescription}>Flexão</h4>
          <Output
            text="fm,d"
            value={bendingCombinedOutputs["fm_d"]}
            unit="MPa"
          />
          <h4>Momento em torno do eixo X</h4>
          <Output
            text="σMx,d"
            value={bendingCombinedOutputs["tens_mx_d"]}
            unit="MPa"
          />
          {bendingCombinedOutputs["tens_mx_d"] !== "" && (
            <h4 className={styles.rowDescription}>
              {bendingCombinedOutputs["tens_mx_d"].toFixed(2) +
                " ≤ " +
                bendingCombinedOutputs["fm_d"].toFixed(2) +
                " → "}
              {bendingCombinedOutputs["tens_mx_d"] <=
              bendingCombinedOutputs["fm_d"].toFixed(2)
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          <h4>Estabilidade lateral</h4>
          {bendingCombinedOutputs["tens_mx_d"] !== "" &&
            (bendingCombinedInputs["lx"] / bendingCombinedInputs["b"] <=
            bendingCombinedOutputs["limit_1"] ? (
              <h4 className={styles.rowDescription}>
                {(
                  bendingCombinedInputs["lx"] / bendingCombinedInputs["b"]
                ).toFixed(2) +
                  " ≤ " +
                  bendingCombinedOutputs["limit_1"].toFixed(2) +
                  " → OK!"}
              </h4>
            ) : (
              <h4 className={styles.rowDescription}>
                {bendingCombinedOutputs["tens_mx_d"].toFixed(2) +
                  " ≤ " +
                  bendingCombinedOutputs["limit_2"].toFixed(2) +
                  " → "}
                {bendingCombinedOutputs["tens_mx_d"] <=
                bendingCombinedOutputs["limit_2"]
                  ? "OK!"
                  : "NÃO OK!"}
              </h4>
            ))}
          {bendingCombinedInputs["stress_type"] === "Tração" ? (
            <>
              <h4 className={styles.rowDescription}>Tração</h4>
              <Output
                text="ft0,d"
                value={bendingCombinedOutputs["ft0_d"]}
                unit="MPa"
              />
              {bendingCombinedOutputs["l0_x"] === "" ? (
                <h4 className={styles.rowDescription}>L0,x =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"L0,x = " +
                    bendingCombinedOutputs["l0_x"].toFixed(2) +
                    " ≤ " +
                    (50 * bendingCombinedInputs["h"]).toFixed(2) +
                    " → "}
                  {bendingCombinedOutputs["l0_x"] <=
                  50 * bendingCombinedInputs["h"]
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedOutputs["l0_y"] === "" ? (
                <h4 className={styles.rowDescription}>L0,y =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"L0,y = " +
                    bendingCombinedOutputs["l0_y"].toFixed(2) +
                    " ≤ " +
                    (50 * bendingCombinedInputs["b"]).toFixed(2) +
                    " → "}
                  {bendingCombinedOutputs["l0_y"] <=
                  50 * bendingCombinedInputs["b"]
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              <Output
                text="σNt,d"
                value={bendingCombinedOutputs["tens_nt_d"]}
                unit="MPa"
              />
              {bendingCombinedOutputs["tens_nt_d"] !== "" && (
                <h4 className={styles.rowDescription}>
                  {bendingCombinedOutputs["tens_nt_d"].toFixed(2) +
                    " ≤ " +
                    bendingCombinedOutputs["ft0_d"].toFixed(2) +
                    " → "}
                  {bendingCombinedOutputs["tens_nt_d"] <=
                  bendingCombinedOutputs["ft0_d"].toFixed(2)
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
            </>
          ) : (
            <>
              <h4 className={styles.rowDescription}>Compressão</h4>
              <Output
                text="fc0,d"
                value={bendingCombinedOutputs["fc0_d"]}
                unit="MPa"
              />
              {bendingCombinedOutputs["l0_x"] === "" ? (
                <h4 className={styles.rowDescription}>L0,x =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"L0,x = " +
                    bendingCombinedOutputs["l0_x"].toFixed(2) +
                    " ≤ " +
                    (40 * bendingCombinedInputs["h"]).toFixed(2) +
                    " → "}
                  {bendingCombinedOutputs["l0_x"] <=
                  40 * bendingCombinedInputs["h"]
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedOutputs["l0_y"] === "" ? (
                <h4 className={styles.rowDescription}>L0,y =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"L0,y = " +
                    bendingCombinedOutputs["l0_y"].toFixed(2) +
                    " ≤ " +
                    (40 * bendingCombinedInputs["b"]).toFixed(2) +
                    " → "}
                  {bendingCombinedOutputs["l0_y"] <=
                  40 * bendingCombinedInputs["b"]
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedOutputs["lambd_x"] === "" ? (
                <h4 className={styles.rowDescription}>λx =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"λx = " +
                    bendingCombinedOutputs["lambd_x"].toFixed(2) +
                    " ≤ 140 → "}
                  {bendingCombinedOutputs["lambd_x"] <= 140 ? "OK!" : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedOutputs["lambd_y"] === "" ? (
                <h4 className={styles.rowDescription}>λy =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"λy = " +
                    bendingCombinedOutputs["lambd_y"].toFixed(2) +
                    " ≤ 140 → "}
                  {bendingCombinedOutputs["lambd_y"] <= 140 ? "OK!" : "NÃO OK!"}
                </h4>
              )}
              <Output
                text="σNc,d"
                value={bendingCombinedOutputs["tens_nc_d"]}
                unit="MPa"
              />
              {bendingCombinedOutputs["tens_nc_d"] !== "" && (
                <h4 className={styles.rowDescription}>
                  {bendingCombinedOutputs["tens_nc_d"].toFixed(2) +
                    " ≤ " +
                    bendingCombinedOutputs["fc0_d"].toFixed(2) +
                    " → "}
                  {bendingCombinedOutputs["tens_nc_d"] <=
                  bendingCombinedOutputs["fc0_d"].toFixed(2)
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              <h4>Estabilidade - Eixo X</h4>
              {bendingCombinedOutputs["lambd_rel_x"] === "" ? (
                <h4 className={styles.rowDescription}>λrel,x =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"λrel,x = " +
                    bendingCombinedOutputs["lambd_rel_x"].toFixed(2) +
                    " ≤ 0.3 → "}
                  {bendingCombinedOutputs["lambd_rel_x"] <= 0.3
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedOutputs["lambd_rel_x"] !== "" &&
                bendingCombinedOutputs["lambd_rel_x"] > 0.3 && (
                  <h4 className={styles.rowDescription}>
                    {bendingCombinedOutputs["verification_x"].toFixed(2) +
                      " ≤ 1 → "}
                    {bendingCombinedOutputs["verification_x"] <= 1
                      ? "OK!"
                      : "NÃO OK!"}
                  </h4>
                )}
              <h4>Estabilidade - Eixo Y</h4>
              {bendingCombinedOutputs["lambd_rel_y"] === "" ? (
                <h4 className={styles.rowDescription}>λrel,y =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"λrel,y = " +
                    bendingCombinedOutputs["lambd_rel_y"].toFixed(2) +
                    " ≤ 0.3 → "}
                  {bendingCombinedOutputs["lambd_rel_y"] <= 0.3
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedOutputs["lambd_rel_y"] !== "" &&
                bendingCombinedOutputs["lambd_rel_y"] > 0.3 && (
                  <h4 className={styles.rowDescription}>
                    {bendingCombinedOutputs["verification_y"].toFixed(2) +
                      " ≤ 1 → "}
                    {bendingCombinedOutputs["verification_y"] <= 1
                      ? "OK!"
                      : "NÃO OK!"}
                  </h4>
                )}
            </>
          )}
          <h4 className={styles.rowDescription}>Flexão Composta Oblíqua</h4>
          {bendingCombinedOutputs["verification"] !== "" && (
            <h4 className={styles.rowDescription}>
              {bendingCombinedOutputs["verification"].toFixed(2) + " ≤ 1 → "}
              {bendingCombinedOutputs["verification"] <= 1 ? "OK!" : "NÃO OK!"}
            </h4>
          )}
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {bendingCombinedOutputs["memorial"] &&
          Object.entries(bendingCombinedOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default TimberBendingCombined;
